import { getProjectListingProjectFit } from '@/api/v4/project-fit.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useQuery } from '@tanstack/react-query';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { PERMISSION } from '@/user/permissions/permission.type';

export const useProjectFit = (projectListingId: string) => {
  const { hasRequiredPermission } = useUserPermissions();
  const hasProjectFitPermission = hasRequiredPermission(
    PERMISSION.VIEW_PROJECT_LISTING,
  );

  return useQuery({
    queryKey: [QueryKey.ProjectListingProjectFit, projectListingId],
    queryFn: () => getProjectListingProjectFit(projectListingId),
    enabled: !!projectListingId && hasProjectFitPermission,
    staleTime: getTimeInMs(5, 'minute'),
  });
};
